enum TriggerValueType {
    Field = 1,
    Profile = 2, 
    Static = 3
}

export { TriggerValueType };